export default __webpack_public_path__ + "static/we-are-what-we-eat-905e74f45735c58af08ea222a15cf786.png";